import React from "react";

const BTNCLORegionsContent = () => {
  const regions = [
    { name: "Polda Papua", region: "Papua", border: "Papua New Guinea" },
    { name: "Polda NTT", region: "Nusa Tenggara Timur", border: "Timor Leste" },
    {
      name: "Polda Kalimantan Utara",
      region: "Kalimantan Utara",
      border: "Malaysia",
    },
    {
      name: "Polda Kalimantan Barat",
      region: "Kalimantan Barat",
      border: "Malaysia",
    },
    {
      name: "Polda Kalimantan Timur",
      region: "Kalimantan Timur",
      border: "Malaysia",
    },
    {
      name: "Polda DIY",
      region: "Daerah Istimewa Yogyakarta",
      border: "Zona Khusus",
    },
    { name: "Polda Jawa Timur", region: "Jawa Timur", border: "Zona Khusus" },
    {
      name: "Polda Kepulauan Riau",
      region: "Kepulauan Riau",
      border: "Singapura/Malaysia",
    },
    { name: "Polda Riau", region: "Riau", border: "Malaysia" },
    { name: "Polda Bali", region: "Bali", border: "Zona Khusus" },
    {
      name: "Polda Sumatera Utara",
      region: "Sumatera Utara",
      border: "Malaysia",
    },
    {
      name: "Polda Sulawesi Utara",
      region: "Sulawesi Utara",
      border: "Filipina",
    },
    { name: "Polda Aceh", region: "Aceh", border: "Malaysia" },
  ];

  const getLogoPath = (poldaName: string) => {
    const logoMap: { [key: string]: string } = {
      "Polda Papua": "POLDA PAPUA.png",
      "Polda NTT": "POLDA NTT.png",
      "Polda Kalimantan Utara": "POLDA KALIMANTAN UTARA.png",
      "Polda Kalimantan Barat": "POLDA KALIMANTAN BARAT.png",
      "Polda Kalimantan Timur": "POLDA KALIMANTAN TIMUR.png",
      "Polda DIY": "POLDA D.I. YOGYAKARTA.png",
      "Polda Jawa Timur": "POLDA JAWA TIMUR.png",
      "Polda Kepulauan Riau": "POLDA KEPULAUAN RIAU.png",
      "Polda Riau": "POLDA RIAU.png",
      "Polda Bali": "POLDA BALI.png",
      "Polda Sumatera Utara": "POLDA SUMATERA UTARA.png",
      "Polda Sulawesi Utara": "POLDA SULAWESI UTARA.png",
      "Polda Aceh": "POLDA ACEH.png",
    };

    return `/static/logo/${logoMap[poldaName] || "DIVHUBINTER.png"}`;
  };

  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Header Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">13 Polda dengan BTNCLO</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <p className="text-base-content/70 leading-relaxed">
              BTNCLO ditempatkan di 13 Polda yang memiliki wilayah perbatasan
              strategis untuk menanggulangi kejahatan transnasional dan
              memfasilitasi koordinasi internasional.
            </p>
          </div>
        </div>

        {/* Regional Statistics */}
        <div className="bg-base-200 rounded-xl p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🗺️</span>
              </div>
              <h3 className="font-semibold text-lg mb-2">Total Polda</h3>
              <p className="text-3xl font-bold">13</p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="bg-secondary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🌏</span>
              </div>
              <h3 className="font-semibold text-lg mb-2">Negara Perbatasan</h3>
              <p className="text-3xl font-bold">5</p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="bg-accent rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🕰️</span>
              </div>
              <h3 className="font-semibold text-lg mb-2">Operasional</h3>
              <p className="text-3xl font-bold">24/7</p>
            </div>
          </div>
        </div>

        {/* Regions List */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Daftar Wilayah BTNCLO</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {regions.map((region, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                    <img
                      src={getLogoPath(region.name)}
                      alt={`${region.name} Logo`}
                      className="w-12 h-12 object-contain"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-2">
                      {region.name}
                    </h3>
                    <p className="text-base-content/70 mb-1">
                      <span className="font-medium">Wilayah:</span>{" "}
                      {region.region}
                    </p>
                    <p className="text-base-content/70">
                      <span className="font-medium">Perbatasan:</span>{" "}
                      {region.border}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Coverage Map Info */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Cakupan Wilayah Strategis</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4">
                Wilayah Perbatasan Darat
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  Kalimantan - Malaysia
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  Papua - Papua New Guinea
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  NTT - Timor Leste
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">•</span>
                  Sumatera - Malaysia
                </li>
              </ul>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4">
                Wilayah Perbatasan Laut
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <span className="text-secondary">•</span>
                  Kepulauan Riau - Singapura
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-secondary">•</span>
                  Sulawesi Utara - Filipina
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-secondary">•</span>
                  Zona Khusus - Jawa & Bali
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BTNCLORegionsContent;
